
const initialState = {
    loading: false,
    error: null,
    userData: null,
    message: null,
};

const AuthenticationAction = {
    LoginUserRequest: "LoginUserRequest",
    LoginUserSuccess: "LoginUserSuccess",
    LoginUserError: "LoginUserError",
    Logout: "Logout",
};

export function LoginUserRequest() {
    return { type: AuthenticationAction.LoginUserRequest };
}

export function LoginUserSuccess(response) {
    return {
        type: AuthenticationAction.LoginUserSuccess,
        payload: response,
    };
}

export function LoginUserError(error) {
    return {
        type: AuthenticationAction.LoginUserError,
        payload: error,
    };
}

export function Logout() {
    return { type: AuthenticationAction.Logout };
}
const reducer = (state, action) => {
    switch (action.type) {
        case AuthenticationAction.LoginUserRequest:
            return { ...state, loading: true, error: null };

        case AuthenticationAction.LoginUserSuccess:
            const newState = { ...state, userData: action.payload, loading: false };
            localStorage.setItem("userData", JSON.stringify(action.payload));
            return newState;

        case AuthenticationAction.Logout:
            localStorage.removeItem("userData");
            localStorage.removeItem('listOfAnswer');
            localStorage.removeItem('patientProfile');
            return { ...state, userData: null };
        
        case AuthenticationAction.LoginUserError:

            return { ...state, error: action.payload, loading: false };

        default:
            throw new Error(
                "Error while processing action: authenticationReducer.reducer"
            );
    }
};

const authenticationReducer = { initialState, reducer };

export default authenticationReducer;

// TODO: Message has to be clear other wise it will repeat
